import { envDomain } from '@/common/contact-selector/utils/domainConfig';

function searchCompanyWeChatOrgByName(params) {
    return Vue.prototype.$_sAjax.crossGet(`${envDomain.gateway}/v1/wework/SearchUser`, {
        params
    });
}

export default function(params) {
    return new Promise((resolve, reject) => {
        const args = {
            keyword: params.name,
            page: params.pageInfo.index,
            size: params.pageInfo.size
        };
        searchCompanyWeChatOrgByName(args).then(
            res => {
                const data = res.data.users.map(x => {
                    return {
                        ...x,
                        face: x.avatar,
                        id: x.userid
                    };
                });
                resolve({
                    list: data,
                    params: {
                        index: res.data.page,
                        size: res.data.size,
                        end: data.length === 0
                    }
                });
            },
            err => {
                reject(err);
            }
        );
    });
}
